import Vue from 'vue';
import Swiper, { Autoplay } from 'swiper';

Swiper.use([Autoplay]);

Vue.component('ticker-team-component', {
    props: {
        reverse: {
            type: Boolean
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            swiperSlider: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.init();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        init() {
            this.initSwiper();
        },

        initSwiper() {
            var swiperOptions = {
                slidesPerView: "1.5",
                loop: true,
                //freeMode: true,
                grabCursor: true,
                loop: true,
                spaceBetween: 6,
                autoplay: {
                    delay: 0,
                    pauseOnMouseEnter: true,
                    reverseDirection: this.reverse,
                },
                speed: 7000,
                freeModeMomentum: false,
                breakpoints: {
                    768: {
                        slidesPerView: "3.5",
                        spaceBetween: 24
                    }
                }
            };

            this.swiperSlider = new Swiper(this.$refs.ticker, swiperOptions);
        },

        destroySwiper() {
            if (!this.swiperSlider) {
                return;
            }

            this.swiperSlider.destroy();
            this.swiperSlider = null;
        },
    }
});
